export interface CuroOpsAccessUser {
  company_id?: string;
  email?: string;
  role?: string;
  permissions?: string[];
}

const ANI_INTERNAL_EMAIL_SUFFIX = "@ani.tech";

function isAniPlatformStaffUser(
  user: CuroOpsAccessUser | null | undefined,
): boolean {
  if ((user?.company_id ?? "").toLowerCase() === "ani") {
    return true;
  }
  return (user?.email ?? "").toLowerCase().endsWith(ANI_INTERNAL_EMAIL_SUFFIX);
}

function hasAdminGrant(
  role: string | undefined,
  permissions: string[] | undefined,
): boolean {
  const normalizedRole = (role ?? "").toLowerCase();
  if (normalizedRole === "admin" || normalizedRole === "super_admin") {
    return true;
  }
  const perms = permissions ?? [];
  return perms.includes("*") || perms.includes("admin:*");
}

/** Mirrors API `permissions.is_admin()` for tenant and platform admins (and M2M `*` grants). */
export function isAdminUser(user: CuroOpsAccessUser | null | undefined): boolean {
  if (!user) return false;
  return hasAdminGrant(user.role, user.permissions);
}

/** True when Ani platform staff admins may open internal ops explorers. */
export function canAccessAniPlatformAdminOps(
  user: CuroOpsAccessUser | null | undefined,
): boolean {
  if (!isAniPlatformStaffUser(user)) {
    return false;
  }
  return isAdminUser(user);
}

/** True when Ani platform staff may open Curo Connect ops (tenant credentials and explorer). */
export function canAccessCuroOps(
  user: CuroOpsAccessUser | null | undefined,
): boolean {
  return canAccessAniPlatformAdminOps(user);
}
